export default function BonitaSpringsHeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20Bonita%20Springs%20Florida%20coastline%20at%20golden%20hour%2C%20the%20famous%20Barefoot%20Beach%20with%20pristine%20white%20sand%20meeting%20turquoise%20Gulf%20of%20Mexico%20waters%2C%20palm%20trees%20lining%20the%20shore%2C%20luxury%20beachfront%20homes%20visible%20in%20the%20distance%2C%20warm%20sunset%20light%20creating%20golden%20reflections%20on%20calm%20tropical%20waters%2C%20lush%20mangrove%20estuaries%20nearby%2C%20professional%20drone%20photography%20with%20rich%20vibrant%20colors%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=bonitasprings-hero-img&orientation=landscape"
        alt="Bonita Springs Florida Barefoot Beach and turquoise Gulf waters at sunset"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/40"></div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-16 text-center">
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
          Emergency &amp; Expedited Passport Services in Bonita Springs, FL
        </h1>
        <p className="text-white/80 text-lg md:text-xl max-w-3xl mx-auto mb-8 leading-relaxed">
          Snowbird resident whose European river cruise departs in two weeks and your passport just expired? Retiree at Pelican Landing with a last-minute family reunion in Canada? Beachfront condo owner heading north through Toronto Pearson with expired documents? We help Bonita Springs residents — from Barefoot Beach snowbirds to Pelican Landing retirees to seasonal residents splitting time between Florida and Europe — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30&ndash;100% lower than FedEx, Staples, and other third-party passport courier resellers. As fast as 24 hours. A+ BBB rated. No office visit required.
        </p>
        <a
          href="https://fastpassportcenter.com/checkout/"
          className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
        >
          Start My Passport <i className="ri-arrow-right-line"></i>
        </a>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-5 md:gap-8">
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <div className="flex items-center gap-0.5">
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
              <i className="ri-star-fill text-[#F6C344] text-sm"></i>
            </div>
            <span className="font-semibold">4.9 / 5</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-award-line text-[#F6C344] text-base"></i>
            <span>A+ BBB Rating</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-calendar-check-line text-[#F6C344] text-base"></i>
            <span>20+ Years</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-shield-check-line text-[#F6C344] text-base"></i>
            <span>Registered State Dept. Courier</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-price-tag-3-line text-[#F6C344] text-base"></i>
            <span>Best Price Guarantee</span>
          </div>
        </div>
      </div>
    </section>
  );
}